export const getPointInSphere = (
  radius: number,
  seedU: number,
  seedV: number,
  seedR: number
) => {
  const u = seedU
  const v = seedV
  const theta = u * 2 * Math.PI
  const phi = Math.acos(2 * v - 1)
  const r = Math.cbrt(seedR) * radius
  const sinTheta = Math.sin(theta)
  const cosTheta = Math.cos(theta)
  const sinPhi = Math.sin(phi)
  const cosPhi = Math.cos(phi)
  const x = r * sinPhi * cosTheta
  const y = r * sinPhi * sinTheta
  const z = r * cosPhi
  
  return [x, y, z]
}
